"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMultiToReviewModel = (data) => {
    return data.map(d => {
        return {
            id: d.Id,
            comment: d.Comment,
            rating: d.Rating,
            addedAt: d.AddedAt,
            likesCount: d.LikesCount,
            movieId: d.MovieId,
            userId: d.UserId,
            userName: d.UserName,
            image: d.Image,
            isLiked: d.IsLiked
        };
    });
};



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-store/converters/reviewConverter.ts